import { DataService } from '../../data.service';
import { HttpClient } from '@angular/common/http';
import { Oferta } from '../model/oferta';
import { Injectable } from '@angular/core';

@Injectable()
export class BLOferta {

    constructor(
        private dataService: DataService,
        private http: HttpClient) {
    }

    listmasters(language: string): Promise<Oferta[]> {
        const url = 'oferta/trasllat?language=' + language;
        return new Promise<Oferta[]>((resolve, reject) => {
            this.http.get<Oferta[]>(this.dataService.getApiEndpoint(url)).subscribe(data => {
                resolve(data);
            });
        });
    }

    getmaster(id: number, language: string): Promise<Oferta> {
        const url = 'oferta/trasllat/' + id.toString() + '?language=' + language;
        return new Promise<Oferta>((resolve, reject) => {
            this.http.get<Oferta>(this.dataService.getApiEndpoint(url)).subscribe(data => {
                resolve(data);
            });
        });
    }

    getmasterbypla(code: string, language: string): Promise<Oferta> {
        const url = 'oferta/trasllatbypla/' + code + '?language=' + language;
        return new Promise<Oferta>((resolve, reject) => {
            this.http.get<Oferta>(this.dataService.getApiEndpoint(url)).subscribe(data => {
                resolve(data);
            });
        });
    }

}



// WEBPACK FOOTER //
// ./src/app/lib/bl/bloferta.ts